"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnleashYourAcademicVoice() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="224165" id="tecnologia-davanguardia" className="relative bg-background overflow-hidden min-h-[85vh] flex items-center py-20 lg:py-0">
      {}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none select-none overflow-hidden" aria-hidden="true">
        <span className="font-default text-[40rem] leading-none text-primary translate-y-12">
          S
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={contentRef} className="lg:col-span-7 flex flex-col justify-center max-w-3xl">
            <h1 className={`font-default text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-foreground leading-[1.1] mb-6 transition-all duration-700 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "100ms"
          }}>
              La Molecola di Risparmio Idrico
            </h1>
            
            <p className={`font-default text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed transition-all duration-700 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "200ms"
          }}>
              Scopri la tecnologia Solid Dew: una struttura macro-biologica che interagisce con le particelle del suolo per trattenere l'umidità. Ottimizza l'irrigazione e garantisci la salute delle radici con la nostra soluzione d'avanguardia.
            </p>
            
            <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "300ms"
          }}>
              <Button asChild size="lg" className="h-12 px-8 text-base bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-lg shadow-md">
                <Link to="/ProductsPage">
                  Scopri i Prodotti
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base bg-transparent border-primary text-primary hover:bg-accent rounded-lg">
                <Link to="/ResultsPage">
                  <BookOpen className="mr-2 size-5" />
                  Vedi i Risultati
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border border-border shadow-xl bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/soil_structure_macro_tech.png" alt="Struttura macro-biologica del suolo e molecola Solid Dew" className="absolute inset-0 w-full h-[120%] object-cover object-center" style={{
              transform: `translateY(-${offsetY * 0.08}px)`,
              transition: 'transform 0.1s ease-out'
            }} />
              {}
              <div className="absolute inset-0 ring-1 ring-inset ring-primary/10 rounded-xl pointer-events-none"></div>
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-secondary/10 rounded-lg blur-2xl -z-10"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/5 rounded-lg blur-3xl -z-10"></div>
          </div>

        </div>
      </div>
    </section>;
}